const body = document.body;
let scrollpos

/**
 * @description オーバーレイ表示
 */
const bodyFixedOff = () => {
  body.classList.remove('is-fixed')
  window.scrollTo(0, scrollpos)
};

/**
 * @description オーバーレイ非表示
 */
const bodyFixedOn = () => {
  scrollpos = window.pageYOffset
  body.classList.add('is-fixed')
  body.style.top = scrollpos * -1 + 'px'
};

/**
 *  背景固定切り替え
 * @param {boolean} state オーバーレイのON, OFFを切り替える真偽値。true=>ON / false=>OFF。
 */
export const bodyFixed = (state) => {
  state ? bodyFixedOn() : bodyFixedOff();
};